import {TranslateService} from '@ngx-translate/core';

export function wordDeclensions(num: any, titles: any, translate: TranslateService) {
  const cases = [2, 0, 1, 1, 1, 2];
  const titleKey = titles[(num % 100 > 4 && num % 100 < 20) ? 2 : cases[(num % 10 < 5) ? num % 10 : 5]];
  return titleKey ? translate.instant(titleKey) : '';
}

export function conjugationOfDay(days: string | number, translate: TranslateService) {
  return days ? days + ' ' + wordDeclensions(days, ['day', 'day_', 'days'], translate) : '';
}
